import React, { createContext, useRef, useCallback } from 'react'
import { useReducer } from 'react'
import { fetchGraphics } from './graphics_menu/fetch'

const store = createContext({})

const { Provider } = store

const actions = {
  SET_LOADING: 'SET_LOADING',
  LOAD_GRAPHICS: 'LOAD_GRAPHICS',
  SET_GRAPHICS: 'SET_GRAPHICS',
  SET_QUERY: 'SET_QUERY',
}

const useEnhancedReducer = (reducer, initState, initializer) => {
  const lastState = useRef(initState)
  const getState = useCallback(() => lastState.current, [])
  return [
    ...useReducer(
      (state, action) => lastState.current = reducer(state, action),
      initState,
      initializer,
    ),
    getState,
  ]
}

const reduce = (state, action) => {
  switch (action.type) {
    case actions.SET_LOADING:
      return { ...state, loading: action.payload }
    case actions.SET_GRAPHICS:
      return { ...state, graphics: action.payload, loading: false }
    case actions.SET_QUERY:
      return { ...state, query: action.payload }
    default:
      return state
  }
}

const StateProvider = (props) => {
  const initialState = {
    ...props,
    graphics: null,
    loading: true,
    query: '',
  }

  const [state, dispatch, getState] = useEnhancedReducer(reduce, initialState)

  const asyncDispatch = (action) => {
    const state = getState()
    switch (action.type) {
      case actions.LOAD_GRAPHICS:
        dispatch({ type: actions.SET_LOADING, payload: true })
        return fetchGraphics(state, dispatch)
      default:
        return dispatch(action)
    }
  }

  const usableData = {
    ...state,
    actions,
  }

  const value = {
    ...usableData,
    dispatch: asyncDispatch.bind(usableData)
  }

  return <Provider value={value}>{props.children}</Provider>
}

export { store, StateProvider, actions }
